import React from 'react';

import { WalletSection } from 'src/components/wallet/wallet-section';

import { EmptyStateCard, EmptyStateSubtitle, EmptyStateTitle } from './recent-activity-section.styles';

export const RECENT_ACTIVITY_SECTION_ID = 'wallet-recent-activity';

export const RecentActivitySection = (): JSX.Element => (
  <WalletSection title='Recent activity' id={RECENT_ACTIVITY_SECTION_ID}>
    <EmptyStateCard>
      <EmptyStateTitle size='small' weight='bold' tag='span'>
        No activity yet
      </EmptyStateTitle>
      <EmptyStateSubtitle size='xsmall' tag='span'>
        Your activity will show up here after using your wallet for purchases.
      </EmptyStateSubtitle>
    </EmptyStateCard>
  </WalletSection>
);
